<template>
  <div class="address-container">
    <div class="heading">
      <div v-if="selectedItem.invoiceAddress">
        <div class="headline">
          <span class="text-h6">{{ selectedItem.invoiceName }}</span>
        </div>

        <div >
          <span class="" v-html="splitAddress(selectedItem.invoiceAddress)"></span>
          <span class="" v-if="selectedItem.postbox2">, {{ selectedItem.postbox2 }}</span>
        </div>

        <div class="mt-3"><span>Client: </span> <span class="primary--text">{{ selectedItem.firstname }} {{ selectedItem.lastname }}</span></div>
      </div>
      <div v-else>
        <div class="text-h6">
          <span class="primary--text">{{ selectedItem.firstname }}</span> {{ selectedItem.lastname }}</div>
          <div >
            <span class="">{{ selectedItem.address }}</span>
            <span class="" v-if="selectedItem.postbox">, {{ selectedItem.postbox }}</span>
          </div>
        <div>
        <span class="">{{ selectedItem.zip }} {{ selectedItem.city }}</span>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['selectedItem'],
  methods: {
    splitAddress (adr) {
      const [street, city, country] = adr.split(',')
      return `${street}<br>${city}`
    }
  }
}
</script>
